module.exports = __webpack_public_path__ + "a1cc032508fd6ac8d7bfad8f629c4b55.MP3";